export interface TokenMap {
  text: Record<string, string>
  color: Record<string, string>
  size: Record<string, string>
  weight: Record<string, string>
  spacing: Record<string, string>
  button: Record<string, string>
  badge: Record<string, string>
  container: Record<string, string>
  layout: Record<string, string>
  [key: string]: Record<string, string>
}

export function resolveTokenClasses(
  tokenMap: TokenMap,
  elementType: string,
  props: Record<string, string | undefined>,
): string {
  const classes: string[] = []

  // Element-type-specific variant resolution
  if (props.variant && tokenMap[elementType]) {
    const typeMap = tokenMap[elementType]
    if (typeMap[props.variant]) {
      classes.push(typeMap[props.variant])
    }
  }

  // Size (element-type-specific)
  if (props.size && tokenMap[elementType]) {
    const typeMap = tokenMap[elementType]
    const sizeKey = `size:${props.size}`
    if (typeMap[sizeKey]) {
      classes.push(typeMap[sizeKey])
    }
  }

  // Color
  if (props.color && tokenMap.color[props.color]) {
    classes.push(tokenMap.color[props.color])
  }

  // Weight
  if (props.weight && tokenMap.weight[props.weight]) {
    classes.push(tokenMap.weight[props.weight])
  }

  // Padding
  if (props.padding && tokenMap.spacing[props.padding]) {
    classes.push(`p-${tokenMap.spacing[props.padding]}`)
  }

  return classes.join(" ")
}
